var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SellerEntity } from "./../../Companies/FileUploadConfiguration/Amazon/SellerEntity";
import { File } from "./File";
export class AmazonFile extends File {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "SellerEntity");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof AmazonFile
     */
    __publicField(this, "$type", "V1.ComplianceUploads.Files.AmazonFile");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      if (_data["SellerEntity"]) {
        const sellerEntity_ = new SellerEntity();
        this.SellerEntity = sellerEntity_.init(_data["SellerEntity"]);
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["SellerEntity"] = this.SellerEntity ? this.SellerEntity.toJSON() : void 0;
    return _data;
  }
}
